<template>
  <span class="message-content" v-html="html"></span>
</template>

<script>
export default {
  name: 'MessageContent',
  props: {
    html: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.message-content {
  display: inline;
}

a {
  color: #3f51b5;
  text-decoration: underline;
}
</style>
